import { defaultEditorTheme } from '../../templateEditor.theme'
import { TemplateElement } from '../../templateEditor.types'

const theme = defaultEditorTheme

type PointerSessionOptions = {
    raf?: boolean
}

export const startPointerSession = (
    onMove: (event: MouseEvent) => void,
    onEnd?: () => void,
    options?: PointerSessionOptions
) => {
    let frameId = 0
    let latestEvent: MouseEvent | null = null

    const flushMove = () => {
        frameId = 0
        if (latestEvent) {
            onMove(latestEvent)
        }
    }

    const handleMove = (event: MouseEvent) => {
        if (!options?.raf) {
            onMove(event)
            return
        }

        latestEvent = event
        if (frameId) {
            return
        }

        frameId = window.requestAnimationFrame(flushMove)
    }

    const onUp = () => {
        window.removeEventListener('mousemove', handleMove)
        window.removeEventListener('mouseup', onUp)

        if (frameId) {
            window.cancelAnimationFrame(frameId)
            frameId = 0
            if (latestEvent) {
                onMove(latestEvent)
            }
        }

        onEnd?.()
    }

    window.addEventListener('mousemove', handleMove)
    window.addEventListener('mouseup', onUp)
}

export const pointerDelta = (event: MouseEvent, startX: number, startY: number, zoom: number) => {
    const scaleFactor = theme.displayScale * zoom
    return {
        dx: (event.clientX - startX) / scaleFactor,
        dy: (event.clientY - startY) / scaleFactor,
    }
}

export const shouldPreserveRatio = (element: TemplateElement) => {
    if (element.type === 'image') {
        return true
    }
    if (element.type === 'shape' && element.shapeKind !== 'line') {
        return true
    }
    return false
}

export const ratioForElement = (element: TemplateElement) => {
    if (element.type === 'image' && element.naturalW && element.naturalH) {
        return element.naturalW / element.naturalH
    }
    return element.w / Math.max(element.h, 1)
}
